import {
    type MoneyMapNumbers,
    type OnboardingChatResults,
    type WelcomeSelection,
} from '@fruitful/types';
import { atom } from 'jotai';

import { StorageKeys } from '../../common/constants';
import { atomWithStorage } from '../../common/providers/StorageProvider';

export const ahaMomentSheetTitleAtom = atom<string | null>(null);
export const moneyMapNumbersAtom = atom<MoneyMapNumbers | null>(null);
export const isChatInputLockedAtom = atom(false);
/** True while the chat thread is fading out before navigating to results. */
export const isChatFadingOutAtom = atom(false);
/** True after bills are confirmed through navigate-away. */
export const isBuildingPlanAtom = atom(false);
/** True once show-intake-summary arrives (plan is ready, holding before navigate). */
export const isPlanReadyAtom = atom(false);

// Set while the user is dragging an interactive control inside a results
// slide (e.g. the spend/goals slider) so the carousel doesn't treat the drag
// as a horizontal swipe and change slides.
export const isResultsCarouselGestureLockedAtom = atom(false);

export const onboardingChatResultsAtom =
    atomWithStorage<OnboardingChatResults | null>(
        StorageKeys.CONVERSATIONAL_MM_ONBOARDING_CHAT_RESULTS,
        null,
    );

/**
 * The member's first-question ("what best describes you?") answer, captured
 * deterministically at commit time and re-derived on restore. Folded into
 * `OnboardingChatResults.welcomeSelection` when the results object is built.
 * Persisted so it survives a refresh before reaching the results/artifact.
 */
export const welcomeSelectionAtom = atomWithStorage<WelcomeSelection | null>(
    StorageKeys.CONVERSATIONAL_MM_WELCOME_SELECTION,
    null,
);
